/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import { Tabs, Tab } from 'react-bootstrap'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { paymentService } from '../../_services/payment.service'
import { memberService } from '../../_services/member.service'
import Modal from 'react-responsive-modal'
import paymentStatuses from '../../_constants/paymentStatuses'
import PicUploaderLiner from '../Shared/PicUploaderLiner'
import DatePicker from '../Shared/DatePicker'
import NumberFormat from 'react-number-format'
import ClassSelect from '../Shared/ClassSelect'
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'
import PaymentStatusSelectForAdmin from '../Shared/PaymentStatusSelectForAdmin'
import { StatusSelect } from '../Shared/StatusSelect'
import PriceInput from '../Shared/PriceInput'
import moment from 'moment-jalaali' // Notice here !

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

import { config } from '../../config'
const base_url = config.apiBaseUrl
export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page + 1
    dto['sorted'] = sorted
    // console.log(JSON.stringify(dto));

    var result = []
    await paymentService
      .getAll(JSON.stringify(dto))
      .then(res => {
        // console.log(res)
        result = res
      })
      .catch(() => {
        setTimeout(
          () => requestData(pageSize, page, sorted, filtered, dto),
          2000
        )
      })

    setTimeout(() => resolve(result), 500)
  })
}

class payment extends Component {
  constructor(props, context) {
    super(props, context)
    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)

    this.state = {
      initialItems: [],
      data: [],
      payments: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      pageSize: pageSize ? pageSize : 10,
      selected: {},
      selectAll: 0,
      dto: {},
      model: {}
    }
  }

  // componentWillMount() {
  //   this.getData()
  // }

  handleModalShow = () => {
    this.setState({ modalHeading: 'جستجو', searchModal: true })
  }

  handleSearchModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ searchModal: false })
  }

  handleModalEdit = async id => {
    this.setState({ loading: true })
    await memberService
      .getById(id)
      .then(res => {
        // console.log(JSON.stringify(res.data));
        let _model = res.data

        var payments = []
        var dto = {}
        dto['pageSize'] = 100
        dto['page'] = 1
        dto['memberId'] = id
        paymentService.getAll(JSON.stringify(dto)).then(res => {
          // console.log(res.data.result);

          payments = res.data.result
          this.setState({
            loading: false,
            EditModalTabsKey: 'info',
            modal: true,
            model: _model,
            payments: payments,
            modalHeading:
              'ویرایش شرکت کننده "' +
              _model.firstName +
              ' ' +
              _model.lastName +
              '"'
          })
        })
      })
      .catch(err => {
        // console.log(err);
      })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  // getData() {

  //   var dto = {
  //     "page": 1,
  //     "pageSize": 5
  //   }
  //   paymentService.getAll(JSON.stringify(dto))
  //     .then((res) => {
  //       console.log(res.data)
  //       var data = res.data;
  //       var pageSize = data.result.length > 10 ? 10 : data.result.length;
  //       this.setState({ initialItems: data, pageSize: pageSize, data: data, loading: false, isSubmitting: false, modal: false });
  //     })
  //     .catch((error) => {
  //       this.handleError(error)
  //     });
  // };

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    paymentService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف تراکنش', 'تراکنش با موفقیت حذف شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleSearch = values => {
    this.setState({ loading: true })
    // console.log(values);

    const { dto } = this.state
    if (values) {
      Object.entries(values).reduce((acc, [key, value]) => {
        dto[key] = value ? value : undefined
      })
      this.setState({ dto: dto }, () => {
        this.table.fireFetchData()
      })
    }
  }

  handleSubmit = values => {
    this.setState({ loading: true })

    // values["imagePath"] = undefined;
    values['createDate'] = undefined
    values['currentClass'] = undefined
    values['union'] = undefined
    values['registerDate'] = undefined
    values['licenseDate'] = undefined
    values['licenseNumber'] = undefined
    values['payments'] = undefined
    if (!values.imagePath) {
      values['imagePath'] = undefined
    }

    // console.log(JSON.stringify(values));
    // var formData = convertToFormData(values)
    paymentService
      .edit(JSON.stringify(values))
      .then(res => {
        toastr.success(
          'ویرایش تراکنش',
          'تراکنش "' +
            values.firstName +
            ' ' +
            values.lastName +
            '" با موفقیت ویرایش شد'
        )
        this.setState({ modal: false })
        this.table.fireFetchData()
      })
      .catch(error => {
        // console.log(error);

        this.handleError(error)
      })
  }

  // componentDidMount(){
  //   this.table.fireFetchData();
  // }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected)
    newSelected[id] = !this.state.selected[id]
    this.setState({
      selected: newSelected,
      selectAll: 2
    })
  }

  toggleSelectAll() {
    let newSelected = {}

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.id] = true
      })
    }
    // console.log(JSON.stringify(newSelected));

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    })
  }

  fetchData = (state, instance) => {
    // console.log(instance);

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        // console.log(res.data.result.length );
        // console.log(state.pageSize );
        if (res.data.result) {
          // var pageSize = res.data.result.length > state.pageSize ? state.pageSize : res.data.result.length;
          // console.log(pageSize );
          this.setState({
            data: res.data.result,
            pages: Math.ceil(res.data.totalRecord / state.pageSize),
            loading: false,
            modal: false,
            searchModal: false
            // pageSize: pageSize,
          })
        }
      })
      .catch(() => {
        this.table.fireFetchData()
      })
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      // name: Yup.string().trim().required('نام تراکنش'),
    })
    const { model, loading, data, pages, pageSize, dto } = this.state
    // console.log(loading);

    return (
      // !loading &&
      <div>
        <a
          onClick={this.handleModalShow}
          className="btn btn-primary react-table-add-btn"
          style={{ alignSelf: 'flex-start' }}>
          <i className="mdi mdi-magnify" />&nbsp;جستجو
        </a>
        <br />
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSize', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            // defaultFilterMethod={(filter, row) =>
            //   String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: 'ردیف',
                id: 'row',
                maxWidth: 50,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.index + 1
                }
              },
              {
                Header: 'نام و نام خانوادگی',
                id: 'fullName',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                accessor: el => el.member.firstName + el.member.lastName,
                filterMethod: (filter, row) => {
                  const escapedStr = filter.value.toLowerCase()
                  const termsArr = escapedStr.split(' ')
                  const finalRegexStr = termsArr.reduce(
                    (acc, curr, idx) => acc + '(?=.*' + curr + ')',
                    ''
                  )
                  const regex = new RegExp(finalRegexStr)
                  return regex.test(row[filter.id])
                },
                Cell: props => (
                  <a
                    onClick={() =>
                      this.handleModalEdit(props.original.member.id)
                    }>
                    <span>
                      {props.original.member.firstName}{' '}
                      {props.original.member.lastName}
                    </span>
                  </a>
                ),
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'اتحادیه',
                accessor: 'union',
                id: 'union',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['union'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => <span>{props.original.member.union.name}</span>
              },
              {
                Header: 'کلاس',
                accessor: 'currentClass',
                id: 'currentClass',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['currentClass'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <span>
                    {props.original.currentClass.lesson
                      ? props.original.currentClass.lesson.name
                      : ''}
                  </span>
                )
              },
              {
                Header: 'هزینه',
                accessor: 'amount',
                id: 'amount',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['amount'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <NumberFormat
                    thousandSeparator={true}
                    className="numberFa"
                    value={props.original.amount}
                    displayType="text"
                    suffix=" ریال"
                  />
                )
              },
              {
                Header: 'تاریخ تراکنش',
                accessor: 'createDate',
                id: 'createDate',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['createDate'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <span>{formatDefaultValue(props.original.createDate)}</span>
                )
              },
              {
                Header: 'وضعیت',
                accessor: 'paymentStatus',
                id: 'paymentStatus',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                Cell: props => (
                  <span>
                    {
                      paymentStatuses.filter(
                        el => el.id === props.original.paymentStatus
                      )[0].name
                    }
                  </span>
                )
              },
              // {
              //     Header: "هزینه",
              //     accessor: "amount",
              //     id: "amount",
              //     style: { display: 'flex', alignItems: 'center', 'justifyContent': 'center' },
              //     filterMethod: (filter, rows) =>
              //         matchSorter(rows, filter.value, { keys: ["amount"] }),
              //     filterAll: true,
              //     Filter: ({ onChange }) =>
              //         <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //     Cell: props => (
              //         <NumberFormat thousandSeparator={true}
              //             className="numberFa"
              //             value={props.original.amount}
              //             displayType="text"
              //             suffix="ریال"
              //         />
              //     )
              // },
              {
                Header: 'جزئیات',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                filterable: false,
                //                     Filter: ({ filter, onChange }) =>
                //                         <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn"
                //                         ><i className="mdi mdi-plus"></i>
                //                             افزودن تراکنش جدید
                // </a>,
                Cell: row => (
                  <div>
                    <a
                      onClick={() =>
                        this.handleModalEdit(row.original.member.id)
                      }
                      className="btn btn-sm btn-simple btn-info bmd-ripple bmd-flat-btn"
                      rel="tooltip"
                      data-original-title="ویرایش">
                      <i className="mdi mdi-information-outline" />
                    </a>
                  </div>
                )
              }
            ]}
            // key={this.state.pageSize}
            // defaultPageSize={this.state.pageSize}
            className="-striped -highlight"
          />
        </div>
        <Modal
          open={this.state.searchModal}
          onClose={this.handleSearchModalHide}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal lg',
            closeButton: 'customModalCloseButton'
          }}>
          <Formik
            initialValues={dto}
            onSubmit={(values, { setSubmitting }) => {
              // console.log(values);
              this.handleSearch(values)
              setSubmitting(false)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit
              } = props
              return (
                <div className="row" style={{ position: 'relative' }}>
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-inline">
                          <div className="col-md-2">
                            <label>نوع تراکنش</label>
                          </div>
                          <div className="col-md-4 rtl">
                            <PaymentStatusSelectForAdmin
                              defaultValue={values.paymentStatus}
                              onChange={val => {
                                setFieldValue('paymentStatus', val)
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="paymentStatus"
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>نام</label>
                          </div>
                          <div className="col-md-4 ">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('firstName', e.target.value)
                              }}
                              value={values.firstName}
                              name="firstName"
                            />
                            {getIn(errors, 'firstName') &&
                            getIn(touched, 'firstName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.firstName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>نام خانوادگی</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('lastName', e.target.value)
                              }}
                              value={values.lastName}
                              name="lastName"
                            />
                            {getIn(errors, 'lastName') &&
                            getIn(touched, 'lastName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.lastName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>از تاریخ</label>
                          </div>
                          <div className="col-md-4">
                            <DatePicker
                              name="fromDate"
                              defaultValue={values.toDate}
                              onChange={val => {
                                setFieldValue('fromDate', val)
                              }}
                            />
                            <ErrorPopUp
                              error={errors.fromDate}
                              touched={touched.fromDate}
                            />
                          </div>

                          <div className="col-lg-2">
                            <label>تا تاریخ</label>
                          </div>
                          <div className="col-md-4">
                            <DatePicker
                              name="toDate"
                              defaultValue={values.toDate}
                              onChange={val => {
                                setFieldValue('toDate', val)
                              }}
                            />
                            <ErrorPopUp
                              error={errors.toDate}
                              touched={touched.toDate}
                            />
                          </div>

                          <div className="clearfix form-row" />

                          <div className="col-md-12">
                            <button
                              type="submit"
                              className={'icon button submit-btn pull-left'}
                              disabled={isSubmitting}>
                              {loading && (
                                <i className="mdi mdi-spin mdi-loading" />
                              )}
                              &nbsp; جستجو &nbsp;
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )
            }}
          </Formik>
        </Modal>

        <Modal
          open={this.state.modal}
          onClose={this.handleModalHide}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal lg memberInfo',
            closeButton: 'customModalCloseButton'
          }}>
          <div>
            <Tabs
              transition={false}
              id="controlled-tab-example"
              className="previewTabs"
              activeKey={this.state.EditModalTabsKey}
              onSelect={EditModalTabsKey =>
                this.setState({ EditModalTabsKey })
              }>
              <Tab eventKey="info" title="اطلاعات شرکت کننده">
                <Formik
                  initialValues={model}
                  onSubmit={(values, { setSubmitting }) => {
                    // console.log(values);
                    this.handleSubmit(values)
                    setSubmitting(false)
                  }}
                  validationSchema={ValidationSchema}>
                  {props => {
                    const {
                      values,
                      touched,
                      errors,
                      isSubmitting,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      handleSubmit
                    } = props
                    return (
                      <div className="row" style={{ position: 'relative' }}>
                        <div className="col-md-12">
                          <form onSubmit={handleSubmit}>
                            <div className="row">
                              <div className="form-inline">
                                {/* <div className="col-md-2">
                                                <label>تقویم کلاس</label>
                                            </div>
                                            <div className="col-md-10 rtl">
                                                <ClassSelect
                                                   
                                                    defaultValue={values.classId}
                                                    onChange={(val) => {
                                                        setFieldValue('classId', val);
                                                    }}
                                                />
                                                <ErrorMessage component={ErrorPopUp} name="classId" />
                                            </div>

                                            <div className="clearfix"></div> */}

                                <div className="col-md-2">
                                  <label>تصویر</label>
                                </div>
                                <div className="col-md-4">
                                  {/* <PicUploaderLinerAdmin label="انتخاب تصویر"
                                    defaultValue={values.imagePath}
                                    onChange={(val) => {
                                      console.log(val);
                                      setFieldValue('imagePath', val);
                                    }}
                                  /> */}
                                  <img
                                    src={
                                      values.imagePath
                                        ? base_url + values.imagePath
                                        : ''
                                    }
                                    alt=""
                                    width="100"
                                    style={{ marginBottom: 10 }}
                                  />
                                </div>

                                <div className="col-md-2">
                                  <label>جنسیت</label>
                                </div>
                                <div className="col-md-4">
                                  <input
                                    type="text"
                                    class="text-input rtl"
                                    disabled
                                    defaultValue={
                                      values.gender === 0 ? 'مرد' : 'زن'
                                    }
                                  />
                                </div>

                                <div className="clearfix" />
                                <div className="col-md-2">
                                  <label>اتحادیه</label>
                                </div>
                                <div className="col-md-10 rtl">
                                  <UnionSelectForAdmin
                                    disabled
                                    defaultValue={values.unionId}
                                    onChange={val => {
                                      setFieldValue('unionId', val)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="unionId"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>نام</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    disabled
                                    value={values.firstName}
                                    onBlur={handleBlur}
                                    name="firstName"
                                    touched={touched.firstName}
                                    className={
                                      getIn(errors, 'firstName') &&
                                      getIn(touched, 'firstName')
                                        ? 'text-input  rtl'
                                        : 'text-input rtl'
                                    }
                                  />
                                  {getIn(errors, 'firstName') &&
                                  getIn(touched, 'firstName') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.firstName}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2">
                                  <label>نام خانوادگی</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    disabled
                                    value={values.lastName}
                                    onBlur={handleBlur}
                                    name="lastName"
                                    touched={touched.lastName}
                                    className={
                                      getIn(errors, 'lastName') &&
                                      getIn(touched, 'lastName')
                                        ? 'text-input  rtl'
                                        : 'text-input rtl'
                                    }
                                  />
                                  {getIn(errors, 'lastName') &&
                                  getIn(touched, 'lastName') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.lastName}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>کد ملی</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    format="##########"
                                    isNumericString
                                    allowNegative={false}
                                    disabled
                                    name="nationalCode"
                                    onChange={e => {
                                      setFieldValue(
                                        'nationalCode',
                                        e.target.value
                                      )
                                    }}
                                    onBlur={handleBlur}
                                    value={values.nationalCode}
                                    className={
                                      errors.nationalCode &&
                                      touched.nationalCode
                                        ? 'text-input numberFa '
                                        : 'text-input numberFa'
                                    }
                                  />

                                  {getIn(errors, 'nationalCode') &&
                                  getIn(touched, 'nationalCode') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.nationalCode}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2">
                                  <label>شماره شناسنامه</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    isNumericString
                                    allowNegative={false}
                                    disabled
                                    name="idNumber"
                                    onChange={e => {
                                      setFieldValue('idNumber', e.target.value)
                                    }}
                                    onBlur={handleBlur}
                                    value={values.idNumber}
                                    className={
                                      errors.idNumber && touched.idNumber
                                        ? 'text-input numberFa '
                                        : 'text-input numberFa'
                                    }
                                  />

                                  {getIn(errors, 'idNumber') &&
                                  getIn(touched, 'idNumber') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.idNumber}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>نام پدر</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    disabled
                                    value={values.fatherName}
                                    onBlur={handleBlur}
                                    name="fatherName"
                                    touched={touched.fatherName}
                                    className={
                                      getIn(errors, 'fatherName') &&
                                      getIn(touched, 'fatherName')
                                        ? 'text-input  rtl'
                                        : 'text-input rtl'
                                    }
                                  />
                                  {getIn(errors, 'fatherName') &&
                                  getIn(touched, 'fatherName') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.fatherName}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="col-md-2">
                                  <label>تاریخ تولد</label>
                                </div>
                                <div className="col-md-4">
                                  <DatePicker
                                    name="expireDate"
                                    disabled
                                    maxDate={moment()}
                                    defaultValue={values.birthDate}
                                    className="rtl"
                                    onChange={val => {
                                      setFieldValue('birthDate', val)
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="birthDate"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>کد رهگیری</label>
                                </div>
                                <div className="col-md-4">
                                  <Field
                                    type="text"
                                    disabled
                                    value={values.isicCode}
                                    onBlur={handleBlur}
                                    name="isicCode"
                                    touched={touched.isicCode}
                                    className={
                                      getIn(errors, 'isicCode') &&
                                      getIn(touched, 'isicCode')
                                        ? 'text-input  rtl'
                                        : 'text-input rtl'
                                    }
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="isicCode"
                                  />
                                </div>

                                <div className="col-md-2">
                                  <label>شماره موبایل</label>
                                </div>
                                <div className="col-md-4">
                                  <NumberFormat
                                    isNumericString
                                    allowNegative={false}
                                    format="###########"
                                    disabled
                                    defaultValue={values.mobile}
                                    name="mobile"
                                    onChange={e => {
                                      setFieldValue('mobile', e.target.value)
                                    }}
                                    onBlur={handleBlur}
                                    className={
                                      getIn(errors, 'mobile') &&
                                      getIn(touched, 'mobile')
                                        ? 'text-input numberFa  rtl'
                                        : 'text-input numberFa rtl'
                                    }
                                  />
                                  {getIn(errors, 'mobile') &&
                                  getIn(touched, 'mobile') ? (
                                    <div
                                      className={'required_validator visible'}>
                                      <div className="validator_container">
                                        <span>{errors.mobile}</span>
                                      </div>
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>وضعیت</label>
                                </div>
                                <div className="col-md-4 rtl">
                                  <StatusSelect
                                    disabled
                                    defaultValue={values.memberStatus}
                                    onChange={val => {
                                      setFieldValue('memberStatus', val)
                                    }}
                                    style={{
                                      height: 40,
                                      background: '#fff',
                                      border: 'thin solid #b4b4b4',
                                      borderRadius: 7
                                    }}
                                  />
                                  <ErrorMessage
                                    component={ErrorPopUp}
                                    name="unionId"
                                  />
                                </div>

                                <div className="clearfix" />

                                <div className="col-md-2">
                                  <label>شماره گواهی</label>
                                </div>
                                <div className="col-md-4 rtl">
                                  <input
                                    type="text"
                                    class="text-input rtl"
                                    disabled
                                    defaultValue={
                                      values.licenseNumber
                                        ? values.licenseNumber
                                        : ''
                                    }
                                  />
                                </div>

                                <div className="col-md-2">
                                  <label>تاریخ گواهی</label>
                                </div>
                                <div className="col-md-4 rtl">
                                  <input
                                    type="text"
                                    class="text-input rtl"
                                    disabled
                                    defaultValue={
                                      values.licenseDate
                                        ? formatDefaultValue(values.licenseDate)
                                        : ''
                                    }
                                  />
                                </div>

                                <div className="clearfix" />

                                {/* <div className="col-md-12">
                                  <br />
                                  <input type="hidden" name="id" value={values.id} />
                                  <button type="submit" className={"icon button submit-btn pull-left"} disabled={isSubmitting} >
                                    {loading &&
                                      <i className="mdi mdi-spin mdi-loading"></i>
                                    }
                                    &nbsp;
                                    ذخیره
                                    &nbsp;
    </button>
                                </div> */}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    )
                  }}
                </Formik>
              </Tab>

              <Tab eventKey="payments" title="اطلاعات پرداخت">
                <table className="table table-striped text-center table-bordered table-hover">
                  <thead>
                    <th className="text-center">ردیف</th>
                    <th className="text-center">تاریخ</th>
                    <th className="text-center">مبلغ</th>
                    <th className="text-center">وضعیت</th>
                    <th className="text-center">کد رهگیری</th>
                  </thead>
                  <tbody>
                    {this.state.payments.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{formatDefaultValue(item.createDate)}</td>
                        <td>
                          <NumberFormat
                            thousandSeparator={true}
                            className="numberFa"
                            value={item.amount}
                            displayType="text"
                            suffix="ریال"
                          />
                        </td>
                        <td>
                          {
                            paymentStatuses.filter(
                              el => el.id === item.paymentStatus
                            )[0].name
                          }
                        </td>
                        <td>{item.referCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Tab>
            </Tabs>
          </div>
        </Modal>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف  [' +
            this.state.model.firstName +
            ' ' +
            this.state.model.lastName +
            '] مطمئن هستید؟'
          }
        />
        {this.state.loading ? <Loading /> : ''}
      </div>
    )
  }
}

export default payment
